import React, { useState } from 'react'

import { Tab } from 'components'
import { IDocumentoCaixaResponseDto } from 'services/NGT/Files'

import {
  NewDocumentation,
  SearchDocumentation,
  EditDocumentation
} from './components'

const RegisterDocumentation: React.FC = () => {
  const [tabs, setTabs] = useState<string[]>(['Pesquisar', 'Adicionar Novo'])
  const [selectedTab, setSelectedTab] = useState<number>(0)
  const [documentoCaixaId, setDocumentoCaixaId] = useState<number | undefined>()
  const [, setDataBoxDocumentation] = useState<IDocumentoCaixaResponseDto>()
  const handleChange = (_, newValue) => {
    if (tabs.length > 2 && newValue === 0) {
      setTabs((prevState) => prevState.slice(0, -1))
    }
    setSelectedTab(newValue)
  }

  const handleEdit = (document: IDocumentoCaixaResponseDto) => {
    if (tabs.length >= 3) {
      setTabs((prevState) => prevState.slice(0, -1))
    }
    setDataBoxDocumentation(document)
    setTabs((prevState) => [...prevState, `${document.codigoContrato}`])
    setSelectedTab(2)
    setDocumentoCaixaId(document.idDocumentoCaixa)
  }

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && <SearchDocumentation handleEdit={handleEdit} />}
      {selectedTab === 1 && <NewDocumentation handleChange={handleChange} />}
      {selectedTab === 2 && (
        <EditDocumentation
          documentoCaixaId={documentoCaixaId}
          handleChange={handleChange}
        />
      )}
    </>
  )
}

export default RegisterDocumentation
